;(function () {
  'use strict'

  angular.module('contrast.trace.events').constant('TRACE_EVENT_LINE_TYPES', {
    TEXT: 'TEXT',
    NORMAL_CODE: 'NORMAL_CODE',
    CODE_STRING: 'CODE_STRING',
    STACKTRACE_LINE: 'STACKTRACE_LINE',
    TAINT_VALUE: 'TAINT_VALUE',
    SOURCE_CODE: 'SOURCE_CODE'
  })
})()
